module.exports = __webpack_public_path__ + "img/IconoVinilTextil.51dedcfb.png";